 
// const THAI_ID_COUTRY = []
const ENGLAND_ID_COUNTRY = [106]
const CHAINA_ID_COUTRY = [99,100,101,102]
const EGYPT_ID_COUTRY = [104]
const GERMANY_ID_COUTRY = [105]
const INDIA_ID_COUTRY = [108]
const JAPAN_ID_COUTRY = [97,98]
const LAOS_ID_COUTRY = [111,114,116,118,390]
const MALASIA_ID_COUTRY = [199]
const RUSSIA_ID_COUTRY = [107]
const SINGAPORE_ID_COUTRY = [121]

const SOUTHKOREA_ID_COUTRY = [96]
const TAIWAN_ID_COUTRY = [103]
const USA_ID_COUTRY = [109]
const MYANMAR_ID_COUTRY = [110]
const VIETNAM_ID_COUTRY = [112,113,115,117,119,120,122,123]
// const BAAC = [799]
// const GSV = [800]
// const BAAC = [94]
// const GSV = [95]
// const BANCK_ICON = [1,2,3,4,5,6,12,14]

const SOUTHKOREA_NAME_COUTRY = 'เกาหลี'
const MALASIA_NAME_COUTRY = 'มาเล'
const VIETNAM_NAME_COUTRY = 'ฮานอย'
const LAOS_NAME_COUTRY = 'ลาว'
const JAPAN_NAME_COUTRY = 'นิเคอิ'
const CHAINA_NAME_COUTRY = 'จีน'
const TAIWAN_NAME_COUTRY = 'ไต้หวัน'
const EGYPT_NAME_COUTRY = 'อียิปต์'
const GERMANY_NAME_COUTRY = 'เยอรมัน'
const ENGLAND_NAME_COUNTRY = 'อังกฤษ'
const RUSSIA_NAME_COUNTRY = 'รัสเซีย'
const INDIA_NAME_COUTRY = 'อินเดีย'
const USA_NAME_COUTRY = 'ดาวน์โจน'
const SINGAPORE_NAME_COUTRY = 'สิงคโปร์'
const HONG_KONG_NAME_COUNTRY = 'ฮั่งเส็ง'

const YEEKEE_NAME = 'ยี่กี'
const BAAC_NAME = 'ธกส'
const GSV_NAME = 'ออมสิน'

// const PATH_IMAGE = '@/assets/countrysvg/'

const checkInclude = (arrayId = [],id) => {
   return arrayId.includes(id)
} 

const checkContain = (target, word) => {
   return word && word.includes(target)
}

const mapImageCoutry = (id, name) => { 
   switch(true){
      case checkContain(ENGLAND_NAME_COUNTRY, name):
         return require('@/assets/countrysvg/england.svg') 
      case checkContain(CHAINA_NAME_COUTRY, name):
         return require('@/assets/countrysvg/china.svg')
      case checkContain(EGYPT_NAME_COUTRY, name):
         return require('@/assets/countrysvg/egypt.svg')
      case checkContain(GERMANY_NAME_COUTRY, name):
         return require('@/assets/countrysvg/germany.svg')
      case checkContain(INDIA_NAME_COUTRY, name):
         return require('@/assets/countrysvg/india.svg')
      case checkContain(JAPAN_NAME_COUTRY, name):
         return require('@/assets/countrysvg/japan.svg')
      case checkContain(LAOS_NAME_COUTRY, name):
         return require('@/assets/countrysvg/laos.png')
      case checkContain(MALASIA_NAME_COUTRY, name):
         return require('@/assets/countrysvg/malaysia.svg')
      case checkContain(RUSSIA_NAME_COUNTRY, name):
         return require('@/assets/countrysvg/russian.svg')
      case checkContain(SINGAPORE_NAME_COUTRY, name):
         return require('@/assets/countrysvg/singapore.svg')
      case checkContain(SOUTHKOREA_NAME_COUTRY, name):
         return require('@/assets/countrysvg/south-korea.svg')
      case checkContain(TAIWAN_NAME_COUTRY, name):
         return require('@/assets/countrysvg/taiwan.png')
      case checkContain(USA_NAME_COUTRY, name):
         return require('@/assets/countrysvg/usa.svg')
      case checkContain(VIETNAM_NAME_COUTRY, name):
         return require('@/assets/countrysvg/vietnam.svg')
      case checkInclude(MYANMAR_ID_COUTRY,id):
         return require('@/assets/countrysvg/myanmar.svg')
      case checkContain(BAAC_NAME, name):
         return require('@/assets/countrysvg/baac.png')
      case checkContain(GSV_NAME, name):
         return require('@/assets/countrysvg/gsv.png')
      case checkContain(YEEKEE_NAME, name):
         return require('@/assets/countrysvg/yeekee.png')
      case checkContain(HONG_KONG_NAME_COUNTRY, name):
         return require('@/assets/countrysvg/hong_kong.png')
      default:
         return require('@/assets/countrysvg/thailand.svg') 
   } 
}
const mapImageCoutry2 = (id) => { 
   switch(true){
      case checkInclude(ENGLAND_ID_COUNTRY,id):
         return require('@/assets/countrysvg-square/england.svg') 
      case checkInclude(CHAINA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/china.svg')
      case checkInclude(EGYPT_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/egypt.svg')
      case checkInclude(GERMANY_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/germany.svg')
      case checkInclude(INDIA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/india.svg')
      case checkInclude(JAPAN_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/japan.svg')
      case checkInclude(LAOS_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/laos.svg')
      case checkInclude(MALASIA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/malaysia.svg')
      case checkInclude(RUSSIA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/russian.svg')
      case checkInclude(SINGAPORE_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/singapore.svg')
      case checkInclude(SOUTHKOREA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/south-korea.svg')
      case checkInclude(TAIWAN_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/taiwan.svg')
      case checkInclude(USA_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/usa.svg')
      case checkInclude(VIETNAM_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/vietnam.svg')
      case checkInclude(MYANMAR_ID_COUTRY,id):
         return require('@/assets/countrysvg-square/myanmar.svg')
      default:
         return require('@/assets/countrysvg-square/thailand.svg') 
   } 
}

export const imagePath = (id, name = null) => {
   return mapImageCoutry(id, name) 
}

export const imagePathLogin = (id) => {
   return mapImageCoutry2(id) 
} 

export const bankIconPath = (id) => {
   try {
      return require(`@/assets/bankimg/${id}.png`)
   } catch {
      return require(`@/assets/bankimg/undefined.png`)
   } 
}

export const externalGamePath = (id) => {
   try {
      return require(`@/assets/externalgame/${id}.svg`)
   } catch {
      return require(`@/assets/anything/image-placeholder.svg`)
   } 
}